// extracted by mini-css-extract-plugin
export var camp = "camp-experience-module--camp--c0b98";
export var campBody = "camp-experience-module--campBody--c9bc9";
export var campDesc = "camp-experience-module--campDesc--77712";
export var campIcons = "camp-experience-module--campIcons--df22e";
export var campIconsIcon = "camp-experience-module--campIconsIcon--e64a6";
export var campImage = "camp-experience-module--campImage--6a9e0";
export var campImageWrapper = "camp-experience-module--campImageWrapper--a0744";
export var campTitle = "camp-experience-module--campTitle--bbdc0";